import { Navigate, useParams } from 'react-router-dom';
import { EmptyState } from '../components/ui/empty-state';
import { LoadingState } from '../components/ui/loading-state';
import { usePermissions } from '../components/rbac/use-permission';
import { deriveNavigation, findNavNode } from '../lib/rbac/navigation';

/**
 * Menüpunkt ohne eigene Seite (z. B. „Protokollierung & Logs“): ein leerer Zustand
 * statt einer Fehlermeldung. Erreichbar nur, wenn der Punkt für den Benutzer sichtbar ist.
 */
const LeererBereich = () => {
  const { nodeId } = useParams();
  const { status, permissions } = usePermissions();
  if (status === 'loading') return <LoadingState />;
  const node = status === 'ready' ? findNavNode(deriveNavigation(permissions), nodeId) : undefined;
  if (!node) return <Navigate to="/kein-zugriff" replace />;
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">{node.label}</h1>
      <EmptyState message="Für diesen Bereich gibt es in der Oberfläche noch keine Seite." />
    </div>
  );
};

export default LeererBereich;
